import React from 'react';

import ModifyButton from 'components/atoms/Button/ModifyButton';

import './index.scss';

const SpConfOdItem = ({ text, children, modifyLinks }) => {
    return (
        <div className="SpConfOdItem">
            <div className="tagArea">
                <label className="tag">{text}</label>
            </div>

            <div className="">
                <span className="items">
                    {children}
                </span>
                <span className="modify-button-area">
                    <span className="">
                        <ModifyButton onClick={modifyLinks} />
                    </span>
                </span>
            </div>
        </div>
    );
};

export default SpConfOdItem;